<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "edit-ownership-information.title" | t }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'edit-ownership-information.instructionText' | t
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "edit-ownership-information.subTitle" | t }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <app-cerrix-tree-item-picker-single
                name="asset-organization-owner"
                data-uiid="asset-edit-organization-owner"
                appValidationRequired
                [items]="organizationsList"
                [selectedValue]="editModel.owningOrganizationId"
                [label]="'detail.organizationOwnerLabel' | t"
                [placeholder]="
                    'edit-ownership-information.organizationPlaceholder' | t
                "
                [dialogTitle]="
                    'edit-ownership-information.organizationDialogTitle' | t
                "
                [infoText]="
                    'edit-ownership-information.organizationOwnerInfo' | t
                "
                iconPrefix="third-party"
                defaultIcon="third-party"
                (valueChanged)="editModel.owningOrganizationId = $event"
            ></app-cerrix-tree-item-picker-single>
            <app-cerrix-user-picker
                name="asset-owner"
                data-uiid="asset-edit-owner"
                [users]="userList"
                [(value)]="editModel.ownerId"
                [label]="'edit-ownership-information.ownerLabel' | t"
                [infoText]="'edit-ownership-information.ownerInfo' | t"
            ></app-cerrix-user-picker>
        </div>
    }
</div>
<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="closeEdit.emit()"
    >
        {{ "detail.cancelButton" | t }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="save()"
    >
        {{ "detail.editSaveButton" | t }}
    </cerrix-button>
</div>
